import Container from "@components/Atomic/Container/Container";
import { Image } from "@components/Image/Image";
import React, { lazy, Suspense } from "react";
import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import tw from "twin.macro";
import { withResponsiveSwiper } from "./withResponsiveSwiper";

const Swiper = lazy(
  () => import(/* webpackChunkName: "swiper" */ "../../Swiper/Swiper"),
);

const Wrapper = tw.section`
  w-full max-w-2xl mx-auto py-maxi md:px-maxi xl:px-tera
`;
const Content = tw.div`
  text-center
`;
const Desktop = tw.div`
  hidden md:block
`;
const Mobile = tw.div`
  block md:hidden
`;

SwiperCore.use([Pagination]);

const ResponsiveSwiper = withResponsiveSwiper(
  ({ content, desktopImages, mobileImages, styles }) => (
    <Container styles={styles} data-component-type="section-responsive-swiper">
      <Wrapper>
        <Content>{content}</Content>
        <Desktop>
          <Suspense fallback={<></>}>
            <Swiper
              watchOverflow={true}
              slidesPerView={1}
              pagination={{ clickable: true }}
              observer={true}
              observeParents={true}
            >
              {desktopImages?.map((image) => (
                <SwiperSlide key={image?._key}>
                  <Image alt={image?.alt} image={image} />
                </SwiperSlide>
              ))}
            </Swiper>
          </Suspense>
        </Desktop>
        <Mobile>
          <Suspense fallback={<></>}>
            <Swiper
              watchOverflow={true}
              slidesPerView={1}
              pagination={{ clickable: true }}
              observer={true}
              observeParents={true}
            >
              {mobileImages?.map((image) => (
                <SwiperSlide key={image?._key}>
                  <Image alt={image?.alt} image={image} />
                </SwiperSlide>
              ))}
            </Swiper>
          </Suspense>
        </Mobile>
      </Wrapper>
    </Container>
  ),
);

export default ResponsiveSwiper;
